import React from 'react'
import { useTranslation } from 'react-i18next'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type OrderStepCardProps = React.PropsWithChildren<{
  disabled?: boolean
  isFirst?: boolean
  isLast?: boolean
  onComplete?: () => void
  onNext?: () => void
  onPrevious?: () => void
  title?: React.ReactNode
}>

const StepButton = styled(Button)({
  borderRadius: 0,
  '&.Mui-disabled': {
    backgroundColor: colors.gray300,
  },
})

export function OrderStepCard(props: OrderStepCardProps) {
  const { children, disabled = false, isFirst = false, isLast = false, onComplete, onNext, onPrevious, title } = props
  const { t } = useTranslation()

  return (
    <Box sx={{ width: '100%', maxWidth: '620px' }}>
      <Box
        sx={{
          width: '100%',
          borderRadius: '5px',
          borderBottomRightRadius: 0,
          boxShadow:
            '3px 0 12px 0 rgb(206 206 206 / 11%), 3px 2px 12px 0 rgb(127 127 127 / 9%), 3px 0 12px 0 rgb(137 137 137 / 5%), 10px 10px 40px 0 rgb(255 255 255 / 12%)',
          backgroundColor: '#fff',
          paddingTop: '20px',
        }}
      >
        {title && (
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              minHeight: '60px',
              borderLeft: (theme) => `solid 4px ${theme.palette.primary.main}`,
              pl: '26px',
              fontSize: '22px',
              fontWeight: 600,
              color: (theme) => theme.palette.primary.main,
            }}
          >
            {title}
          </Stack>
        )}
        <Box>{children}</Box>
      </Box>
      <Stack direction="row" alignItems="center" justifyContent="end">
        {!isFirst && (
          <StepButton color="secondary" onClick={onPrevious} startIcon={<ArrowRightAltRoundedIcon sx={{ transform: 'rotate(180deg)' }} />} variant="contained">
            {t('common:button.previous.label')}
          </StepButton>
        )}
        {!isLast ? (
          <StepButton disabled={disabled} endIcon={<ArrowRightAltRoundedIcon />} onClick={onNext} variant="contained">
            {t('common:button.next.label')}
          </StepButton>
        ) : (
          <StepButton disabled={disabled} onClick={onComplete} variant="contained">
            {t('common:button.complete.label')}
          </StepButton>
        )}
      </Stack>
    </Box>
  )
}

export default OrderStepCard
